import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBubbleChart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 5.66675C13.3333 7.3236 11.9902 8.66675 10.3333 8.66675C8.67648 8.66675 7.33333 7.3236 7.33333 5.66675C7.33333 4.00989 8.67648 2.66675 10.3333 2.66675C11.9902 2.66675 13.3333 4.00989 13.3333 5.66675Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 9.33341C6 10.438 5.10457 11.3334 4 11.3334C2.89543 11.3334 2 10.438 2 9.33341C2 8.22885 2.89543 7.33341 4 7.33341C5.10457 7.33341 6 8.22885 6 9.33341Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3333 12.0001C10.3333 12.7365 9.73638 13.3334 9 13.3334C8.26362 13.3334 7.66667 12.7365 7.66667 12.0001C7.66667 11.2637 8.26362 10.6667 9 10.6667C9.73638 10.6667 10.3333 11.2637 10.3333 12.0001Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgBubbleChart);
export default ForwardRef;
